import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowLongTopRightIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/arrow-long-top-right"><path id="icon" d="M18.728 11.657V6H13.071M18.728 6L6 18.728" stroke="currentColor" strokeWidth={1.66667} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowLongTopRightIcon;